import styled, { css } from 'styled-components'
import FormControlLabel, {
  FormControlLabelProps,
} from '@material-ui/core/FormControlLabel'
import RadioGroup, { RadioGroupProps } from '@material-ui/core/RadioGroup'
import FormGroup, { FormGroupProps } from '@material-ui/core/FormGroup'
import Dialog, { DialogProps } from '@material-ui/core/Dialog'
import Select, { SelectProps } from '@material-ui/core/Select'
import Radio, { RadioProps } from '@material-ui/core/Radio'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import { SvgIconProps } from '@material-ui/core/SvgIcon'
import { IScheduleList } from './SchedulesList'
import { colors } from '../../styles'

interface IStyledDatePickerWrapper {
  showTopMargin?: boolean
}

export const StyledModalContainer = styled.div`
  overflow: auto;
`

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px 24px;
  input {
    flex: 1;
  }
`

// TODO: merge with CustomDateListField styled datepicker component into one
export const StyledDatePickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  ${({ showTopMargin }: IStyledDatePickerWrapper) =>
    showTopMargin &&
    css`
      margin-top: 8px;
    `}

  .react-datepicker-wrapper,
  .react-datepicker-popper {
    width: 100%;
    min-width: 315px;
  }

  .react-datepicker-popper[data-placement^='bottom'] {
    margin-top: 2px;
  }

  .react-datepicker {
    font-family: knowledge2017regular;
    font-size: 16px;

    &__triangle {
      display: none;
    }

    &__header {
      height: 54px;
      background: ${colors.white};
    }

    &__header--time {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-time__header {
      color: ${colors.green};
      font-weight: bold;
    }

    &__time-list-item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 !important;

      &:hover,
      &--selected {
        background-color: ${colors.green}!important;
      }
    }

    &__day-names {
      display: flex;
      justify-content: space-around;
    }

    &__day-name {
      margin: 0;
    }

    &__current-month {
      font-size: 16px;
      color: ${colors.green};
    }

    &__week {
      display: flex;
    }

    &__day {
      border-radius: 20px;
      margin: 0.1rem 0.1rem;
      padding: 0;

      &:hover {
        background-color: ${colors.green};
        border-radius: 20px;
        cursor: pointer;
      }

      &-name {
        color: ${colors.green};
      }

      &--selected {
        background-color: ${colors.green};

        &:hover {
          background-color: ${colors.green};
          border-radius: 20px;
        }
      }

      &--outside-month {
        color: ${colors.grey30};
      }
    }

    &__month {
      margin-top: 0;
    }

    &__navigation {
      &--previous {
        border-right-color: ${colors.green};

        &:hover {
          border-right-color: ${colors.green};
        }
      }

      &--next {
        border-left-color: ${colors.green};

        &:hover {
          border-left-color: ${colors.green};
        }
      }
    }
  }
` as React.ComponentType<IStyledDatePickerWrapper>

export const RecurrenceVariantsContainer = styled.div`
  display: flex;
`

export const MonthDropdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .dropdown-adorment {
    width: 10%;
  }
  .generic-dropdown {
    width: 88%;
  }
`

export const RecurrenceWeekdayContainer = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    width: 48%;
  }
`

export const StyledFormControlLabel = styled(FormControlLabel)`
  padding-top: 2px;
` as React.ComponentType<FormControlLabelProps>

export const StyledRadioGroup = styled(RadioGroup)`
  width: 25%;
` as React.ComponentType<RadioGroupProps>

export const StyledFormGroup = styled(FormGroup)`
  width: 75%;
` as React.ComponentType<FormGroupProps>

export const StyledDialog = styled(Dialog)`
  .dialog-paper-root {
    width: 26%;
    min-width: 360px;
    overflow: visible;
  }
` as React.ComponentType<DialogProps>

export const StyledMultiselect = styled(Select)`
  .weekday-select {
    white-space: initial;
  }
` as React.ComponentType<SelectProps>

export const StyledIcon = styled(CalendarTodayIcon)`
  fill: ${colors.green};
` as React.ComponentType<SvgIconProps>

export const StyledRadio = styled(Radio)`
  padding-top: 5px;
  padding-bottom: 5px;
` as React.ComponentType<RadioProps>

export const StyledTextField = styled(TextField)`
  input {
    padding-bottom: 2px;
  }
` as React.ComponentType<TextFieldProps>

export const StyledList = styled.ul`
  padding: 0;
  li {
    width: 70%;
    ${({ publishTab }: IScheduleList) =>
      publishTab &&
      css`
        width: 100%;
      `}
    display: flex;
    align-items: center;
    padding: 4px 0 4px 0px;

    .left-list-item-area {
      width: 7%;
      ${({ publishTab }: IScheduleList) =>
        publishTab &&
        css`
          width: 10%;
        `}
    }

    .text-list-item-area {
      width: 79%;
      ${({ publishTab }: IScheduleList) =>
        publishTab &&
        css`
          width: 68%;
        `}
    }

    .right-list-item-area {
      width: 14%;
      padding-left: 5%;
      ${({ publishTab }: IScheduleList) =>
        publishTab &&
        css`
          width: 22%;
          padding-left: 4%;
        `}
      display: flex;
      justify-content: space-between;
    }

    button {
      padding: 3px;
    }

    .icon {
      font-size: 20px;
      color: ${colors.green};
    }
  }
` as React.ComponentType<IScheduleList>
